import { Text } from "@hangar/web-components/core/Text";
import * as S from './styles/RemittanceInfoLine.style';
import { RemittanceInfoLineProps } from './types';

/**
 * Molecule that displays the company name and the route/code in a line.
 */
const RemittanceInfoLine = ({ branchNumber }: RemittanceInfoLineProps) => {
  return (
    <S.InfoLine>
      <S.BranchNumberText><Text variant="body-md" color="secondary">{branchNumber}</Text></S.BranchNumberText>
    </S.InfoLine>
  );
};

export default RemittanceInfoLine;